module.exports = __webpack_public_path__ + "static/media/02.b1728521.jpg";